// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperAbstract-cls1_Dcx","cls2":"PaperAbstract-cls2_RSW PaperAbstract-cls1_Dcx"};